import React, { useState } from 'react';

const ControlChartConstantsTable = () => {
  const [sampleSize, setSampleSize] = useState(2);
  const [controlConstants, setControlConstants] = useState([]);

  // Function to get control constants for X-bar and R charts based on sample size
  const getControlConstants = (n) => {
    const constants = {
      2: { A2: 1.880, D3: 0.000, D4: 3.267, D2: 1.128 },
      3: { A2: 1.023, D3: 0.000, D4: 2.574, D2: 1.693 },
      4: { A2: 0.729, D3: 0.000, D4: 2.282, D2: 2.223 },
      5: { A2: 0.577, D3: 0.000, D4: 2.114, D2: 2.500 },
      6: { A2: 0.483, D3: 0.000, D4: 2.004, D2: 2.705 },
      7: { A2: 0.419, D3: 0.000, D4: 1.924, D2: 2.853 },
      8: { A2: 0.373, D3: 0.000, D4: 1.864, D2: 2.949 },
      9: { A2: 0.337, D3: 0.000, D4: 1.816, D2: 3.014 },
      10: { A2: 0.308, D3: 0.000, D4: 1.777, D2: 3.055 },
      11: { A2: 0.282, D3: 0.000, D4: 1.745, D2: 3.083 },
      12: { A2: 0.263, D3: 0.000, D4: 1.718, D2: 3.100 },
      13: { A2: 0.247, D3: 0.000, D4: 1.697, D2: 3.108 },
      14: { A2: 0.233, D3: 0.000, D4: 1.679, D2: 3.116 },
      15: { A2: 0.221, D3: 0.000, D4: 1.664, D2: 3.121 },
      16: { A2: 0.210, D3: 0.000, D4: 1.651, D2: 3.127 },
      17: { A2: 0.200, D3: 0.000, D4: 1.640, D2: 3.132 },
      18: { A2: 0.190, D3: 0.000, D4: 1.630, D2: 3.137 },
      19: { A2: 0.182, D3: 0.000, D4: 1.621, D2: 3.141 },
      20: { A2: 0.174, D3: 0.000, D4: 1.612, D2: 3.145 },
      21: { A2: 0.167, D3: 0.000, D4: 1.603, D2: 3.149 },
      22: { A2: 0.160, D3: 0.000, D4: 1.595, D2: 3.153 },
      23: { A2: 0.154, D3: 0.000, D4: 1.587, D2: 3.156 },
      24: { A2: 0.148, D3: 0.000, D4: 1.580, D2: 3.159 },
      25: { A2: 0.143, D3: 0.000, D4: 1.573, D2: 3.162 },
    };
    return constants[n] || {};
  };

  // Function to handle sample size change and update constants
  const handleSampleSizeChange = (e) => {
    const newSampleSize = parseInt(e.target.value);
    setSampleSize(newSampleSize);
    setControlConstants(getControlConstants(newSampleSize));
  };

  return (
    <div>
      <h2>Control Chart Constants Table</h2>
      <label htmlFor="sampleSize">Sample Size (n): </label>
      <input
        type="number"
        id="sampleSize"
        value={sampleSize}
        min="2"
        max="25"
        onChange={handleSampleSizeChange}
      />
      <br />
      <button onClick={() => setControlConstants(getControlConstants(sampleSize))}>
        Generate Table
      </button>

      {controlConstants.A2 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Sample Size (n)</th>
              <th>A2</th>
              <th>D3</th>
              <th>D4</th>
              <th>D2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{sampleSize}</td>
              <td>{controlConstants.A2}</td>
              <td>{controlConstants.D3}</td>
              <td>{controlConstants.D4}</td>
              <td>{controlConstants.D2}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ControlChartConstantsTable;
